import React, { useState } from 'react'
import { DateProp } from '../../../services/create-booking-v4/hooks/useGetAllBookingV4'
import { IconDownload } from '@tabler/icons-react';
import { privateApi } from '../../../api/api';
import { toast } from 'sonner';

interface ExportButtonComponentProps {
    search: string;
    checkinDate?: DateProp;
    checkoutDate?: DateProp;
    createdAt?: DateProp;
    status: string[];
    properties: string;
    agents: string;
    ota_channel: string;
}

const ExportButtonComponent: React.FC<ExportButtonComponentProps> = ({ search, checkinDate, checkoutDate, createdAt, status, properties, agents, ota_channel }) => {
    const [isExporting, setIsExporting] = useState(false);

    const handleExport = async () => {
        try {
            setIsExporting(true);
            toast.loading("Exporting Excel...", { id: 'export-excel' });

            // Map the DateProp (gte/lte) to the export API format
            let date_type = null;
            let date_from = null;
            let date_to = null;

            if (checkinDate?.gte && checkinDate?.lte) {
                date_type = 'arrival';
                date_from = checkinDate.gte;
                date_to = checkinDate.lte;
            } else if (checkoutDate?.gte && checkoutDate?.lte) {
                date_type = 'departure';
                date_from = checkoutDate.gte;
                date_to = checkoutDate.lte;
            } else if (createdAt?.gte && createdAt?.lte) {
                date_type = 'created';
                date_from = createdAt.gte;
                date_to = createdAt.lte;
            }

            const exportFilters: any = {
                property_id: properties,
                search: search,
                status: status.join(','),
                agent_id: agents,
                ota_name: ota_channel,
                date_type: date_type,
                date_from: date_from,
                date_to: date_to,
            };

            // Remove empty strings or nulls to keep the URL clean
            Object.keys(exportFilters).forEach(key => {
                if (!exportFilters[key]) delete exportFilters[key];
            });

            const response = await privateApi.get('v4/booking/export', {
                params: exportFilters,
                responseType: 'blob'
            });

            // Create a blob URL and trigger download
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Bookings_Export_${new Date().getTime()}.xlsx`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

            toast.success("Excel downloaded successfully!", { id: 'export-excel' });
        } catch (error) {
            console.error(error);
            toast.error("Failed to export Excel.", { id: 'export-excel' });
        } finally {
            setIsExporting(false);
        }
    }

    return (
        <button
            className="btn btn-outline-secondary ms-2"
            onClick={handleExport}
            disabled={isExporting || !properties}
        >
            {isExporting ? (
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            ) : (
                <IconDownload size={16} className="me-1" />
            )}
            {isExporting ? 'Exporting...' : 'Export'}
        </button>
    )
}

export default ExportButtonComponent